import React, { Component } from "react";
import { Form, TextArea } from "semantic-ui-react";
import "./msgs.css";
class MessageList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: ""
    };
  }
  handlekeypress(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      if (this.state.message !== "") {
        this.props.Send(this.state.message);
        this.setState({ message: "" });
      }
    }
  }
  render() {
    return (
      <Form>
        <Form.Field
          id="messagesend"
          control={TextArea}
          fluid
          value={this.state.message}
          onKeyPress={e => this.handlekeypress(e)}
          onChange={e => {
            this.setState({ message: e.target.value });
          }}
        />
      </Form>
    );
  }
}
export default MessageList;



// WEBPACK FOOTER //
// ./src/components/messaging/sendmessage.js